import React from 'react';
import { connect } from 'react-redux';
import { accountActions } from '../../../actions/account.action';
import { actionConstants } from '../../../actions/actionConstants';
import { store } from '../../../utils/store';
import ChangePasswordPage from './ChangePasswordPage';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      errors: '',
    };
  }
  onChangePassword = (values) => {
    const _values = Object.assign({}, values);
    _values.newPassword = _values.password;
    this.setState(
      { isSubmitting: true, errors: '' },
      async () =>
        await this.props
          .changeExpiredPassword(_values)
          .then(() => {
            store.dispatch({
              type: actionConstants.PASSWORD_IS_EXPIRED,
              data: false,
            });
            this.props.history.push('/login');
          })
          .catch((error) =>
            this.setState({ isSubmitting: false, errors: error }),
          ),
    );
  };
  render() {
    return (
      <ChangePasswordPage
        {...this.state}
        onChangePassword={this.onChangePassword}
      />
    );
  }
}

export default connect(null, accountActions)(ChangePassword);
